import { render } from "./AddSigningRoom.vue?vue&type=template&id=70dd9cb7"
import script from "./AddSigningRoom.vue?vue&type=script&lang=js"
export * from "./AddSigningRoom.vue?vue&type=script&lang=js"

import "./AddSigningRoom.vue?vue&type=style&index=0&id=70dd9cb7&lang=css"

import exportComponent from "D:\\a\\1\\s\\eNotary.SPA\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__